import { Component, OnInit, OnDestroy } from '@angular/core';
import { SsoAuthService } from '../../../services/sso-auth.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { UiService } from '../../../services/ui.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-ssoauth',
  templateUrl: './ssoauth.component.html',
  styleUrls: ['./ssoauth.component.scss']
})
export class SsoauthComponent implements OnInit, OnDestroy {

  logoCompany = 'https://firebasestorage.googleapis.com/v0/b/bimboakibadev.appspot.com/o/logos%2FLogo_Grupo_BIMBO.svg?alt=media&token=b57a2235-a83d-4fe0-b313-491cfdd00ec5';
  akibaLogoUrl = 'https://firebasestorage.googleapis.com/v0/b/bimboakibadev.appspot.com/o/logos%2FAkiba-Logo.svg?alt=media&token=14dea628-222d-4a20-92ef-632572be8642';
  properties = Array<string>();
  authEmployeeSubscription: Subscription = null;

  constructor(private sso: SsoAuthService, private authService: AuthenticationService, private ui: UiService, private router: Router, public snackBar: MatSnackBar) {

    this.authEmployeeSubscription = this.authService.authUserSubject.subscribe(anEmployee => {

      if (anEmployee) {

        this.ui.stopSpinner();

        this.snackBar.open('Bienvenido.', null, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });

        const path = this.authService.appLevel.sideBarItems[0].path;

        if (this.authService.href) {
          const url = this.authService.href;
          this.authService.href = null;
          this.router.navigate([url]);
        } else {
          this.router.navigate([path]);
        }

      }

    });

  }

  async ngOnInit() {

    if (!this.authService.isAuthenticated) {

      const authUser = this.sso.getAuthUser();
      if (authUser) {

        const model = { employeeNumber: null, email: null };

        this.ui.showSpinner();

        const token = await this.sso.getDecodedToken();

        if (token) {

          const t = JSON.stringify(token);
          console.log(t);

          model.email = token.email ? token.email.toLowerCase() : token.unique_name ? token.unique_name.toLowerCase() : null;

          if (token.hasOwnProperty('employeeid')) {
            model.employeeNumber = String(token.employeeid);
          } else {
            const employeeID = null; // await this.sso.getEmployeeID();
            model.employeeNumber = employeeID && employeeID.value ? employeeID.value : Math.floor(Math.random() * Math.floor(10000000));
          }

          this.authService.signIn(model).then(result => {

            this.ui.stopSpinner();
            if (!result) {
              this.router.navigate(['/mLogin']);
            }

          }).catch(error => {

            this.ui.stopSpinner();
            this.router.navigate(['/mLogin']);

          });

        } else {

          this.ui.stopSpinner();
          this.router.navigate(['/mLogin']);

        }

      } else {
        this.router.navigate(['/mLogin']);
      }

    }

  }

  ngOnDestroy(): void {

    if (this.authEmployeeSubscription && !this.authEmployeeSubscription.closed) {
      this.authEmployeeSubscription.unsubscribe();
      this.authEmployeeSubscription = null;
    }

  }

}
